import { useFormState, useWatch } from 'react-hook-form';
import { requiredOk } from '../../../../utils';

export const useSoftware = (control) => {
  const watchedValues = useWatch({
    control,
    name: ['softwares'],
  });

  const { dirtyFields } = useFormState({ control });

  const formValues = {
    softwares: watchedValues[0],
  };

  const isValid = formValues.softwares?.length !== 0;
  const canSave = requiredOk(dirtyFields.softwares, isValid);

  return {
    formValues,
    isValid,
    canSave,
  };
};
